import React from "react";
import PT from "prop-types";
import get from "lodash/get";
import CustomStoryElement from "../custom-story-elements";
import { DefaultStoryCard } from "../DefaultStoryCard";

export function StoryCard(props) {
  const attribute = get(props, ["card", "metadata", "attributes", "cardtype", "0"], null);
  const { card, story, count, allImagesInCards, counter } = props;
  if (attribute?.toLowerCase() === "hero") {
    return null;
  }
  if (attribute) {
    return <CustomStoryElement card={card} attribute={attribute} story={story} counter={counter} />;
  }
  return (
    <DefaultStoryCard card={card} story={story} count={count} allImagesInCards={allImagesInCards} counter={counter} />
  );
}

StoryCard.propTypes = {
  card: PT.object,
  story: PT.object,
  count: PT.number,
  allImagesInCards: PT.object,
};
